/**
 * Antes envolvia react-i18next. El sitio tiene contenido solo en ingles y el
 * LanguageDropdown ya estaba comentado, asi que i18next + i18next-http-backend +
 * i18next-browser-languagedetector viajaban en el chunk compartido de cada pagina
 * sin traducir nada. Se deja este componente como paso-a-traves para no tocar los
 * 5 componentes de navegacion que lo usan.
 *
 * Si algun dia vuelve el multi-idioma: reinstalar el hook aca y volver a importar
 * src/configs/i18n en _app.js. Los json de public/locales/ siguen en su lugar.
 */
const Translations = ({ text }) => <>{text}</>

export default Translations
